import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.live}/v1`, {
  get: {
    'webinar.schedule': '/schedule/:webinarKey',
    'get.metadata': '/public/url/metadata',
    'get.toggle': '/public/schedule/toggle/:toggleName'
  },
  put: {
    'put.schedule': '/schedule'
  },
  post: {
    'post.save.schedule': '/schedule'
  }
});

Request.register(`${Settings.api.content}/v4/webinars`, {
  get: {
    'webinar.get': '/:id'
  }
});

Request.register(`${Settings.api.content}/v5/webinars`, {
  post: {
    'webinar.create': '/'
  },
  put: {
    'webinar.update': '/:id'
  }
});
